import { actionTypes } from "./mainActions";

export const changeSideBar = (selectedMenu) => {
  return {
    type: actionTypes.CHANGE_SIDE_BAR,
    payload: selectedMenu
  };
};
export const changeSearchBar = (isSearchBar) => {
  return {
    type: actionTypes.SEARCH_BAR,
    payload: isSearchBar
  };
};
export const changeFacility = (selectedFacility) => {
  return {
    type: actionTypes.CHANGE_FACILITY,
    payload: selectedFacility
  };
};
export const searchFacility = (searchFacility) => {
  return {
    type: actionTypes.SEARCH_FACILITY,
    payload: searchFacility
  };
};

export const FacilityName = (facilityName) => {
  return {
    type: actionTypes.FACILITY_NAME,
    payload: facilityName
  };
};

export const refreshMonitorCount = (isRefreshMonitor) => {
  return {
    type: actionTypes.REFRESH_MONITOR,
    payload: isRefreshMonitor
  };
};
export const refreshUsercount = (isRefreshUser) => {
  return {
    type: actionTypes.REFRESH_USER,
    payload: isRefreshUser
  };
};
export const refreshFacitityAcount = (isRefreshFacility) => {
  return {
    type: actionTypes.REFRESH_FACILITY,
    payload: isRefreshFacility
  };
};

export const searchUser = (searchUser) => {
  return {
    type: actionTypes.SEARCH_USER,
    payload: searchUser
  };
};

export const searchMonitor = (searchMonitor) => {
  return {
    type: actionTypes.SEARCH_MONITOR,
    payload: searchMonitor
  };
};

export const monitorDetails = (monitorDetails) => {
  return {
    type: actionTypes.MONITOR_DETAILS,
    payload: monitorDetails
  };
};
export const refreshAudio = (isRefreshAudio) => {
  return {
    type: actionTypes.REFRESH_AUDIO,
    payload: isRefreshAudio
  };
};
export const changefacilityDetails = (facilityDetails) => {
  return {
    type: actionTypes.FACILITY_DETAILS,
    payload: facilityDetails
  };
};
export const refreshAssociateApi = (isAssociateApi) => {
  return {
    type: actionTypes.REFRESH_ASSOCIATE,
    payload: isAssociateApi
  };
};
export const handleDelete = (isDelete) => {
  return {
    type: actionTypes.DELETE_AUDIO,
    payload: isDelete
  };
};
export const handleAudioGrid = (isaudioGrid) => {
  return {
    type: actionTypes.CALL_AUDIOGRID,
    payload: isaudioGrid
  };
};
export const MonitorListRefresh = (monitorListRefresh) => {
  return {
    type: actionTypes.MONITORLIST_REFRESH,
    payload: monitorListRefresh
  };
};
export const UserListRefresh = (userListRefresh) => {
  return {
    type: actionTypes.USERLIST_REFRESH,
    payload: userListRefresh
  };
};
export const FacilityListRefresh = (facilityListRefresh) => {
  return {
    type: actionTypes.FACILITYLIST_REFRESH,
    payload: facilityListRefresh
  };
};